import request from '@/utils/request'
const preFixUrl = '/report'
// 用户检验报告单列表
/**
 * 列表
 * @param {*} data
 * @returns
 */
export const getJyReportList = data => {
  return request({
    url: `${preFixUrl}/outpatientClinic/getJyReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 详情
 * @param {*} id
 * @returns
 */
export const getJyReportDetail = id => {
  return request({
    url: `${preFixUrl}/outpatientClinic/getJyReportDetail/?sheetId=${id}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}


/**
 * 获取检查报告列表
 * @param {*} 
 * @returns
 */
export const getJcReportList = data => {
  return request({
    url: `${preFixUrl}/outpatientClinic/getJcReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 检查详情
 * @param {*} applicationNumber 申请单号
 * @param {*} sign md5签名
 * @returns
 */
export const getJcReportDetail = (applicationNumber,sign) => {
  return request({
    url: `${preFixUrl}/outpatientClinic/getJcReportDetail?applicationNumber=${applicationNumber}&sign=${sign}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

/**
 * 检查报告
 * @param {*} data
 * @returns
 */
export const getPhysicalExam = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 检查报告详情
 * @param {*} idCardNo
 * @returns
 */
export const getPhysicalExamNo = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getReportDetailPost`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取用户体检数据对比分析
 * @param {*} idCardNo
 * @returns
 */
export const getHealthDataList = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getHealthDataList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
/**
 * 获取用户体检数据对比分析-新版
 * @param {*} idCardNo
 * @returns
 */
export const getHealthDataListNew = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getHealthDataListNew`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取项目趋势
 * @param {*} idCardNo
 * @returns
 */
export const getItemTrend = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getItemTrend`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 *体检检查报告列表
 * @param {*} data
 * @returns
 */
export const getPJcReportList = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getJcReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
/**
 *体检检验报告列表
 * @param {*} data
 * @returns
 */
 export const getPJyReportList = data => {
  return request({
    url: `${preFixUrl}/physicalExam/getJyReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}


/**
 * 体检检验报告详情
 * @param {*} idCardNo
 * @returns
 */
export const getPJyReportDetails = (data) => {
  return request({
    url: `${preFixUrl}/physicalExam/getJyReportDetails`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 查看体检结论
 * @param {*} physicalExamNo
 * @returns
 * 
 */
export const getConclusion = (params) => {
  return request({
    url: `${preFixUrl}/physicalExamReportConclusion/detailsByPhysicalExamNo`,
    method: 'get',
    params
  })
}



// 用户检验报告单列表-新
/**
 * 列表
 * @param {*} data
 * @returns
 */
export const getJyReportList2 = data => {
  return request({
    url: `${preFixUrl}/outpatientClinicV2/getJyReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 详情
 * @param {*} id
 * @returns
 */
export const getJyReportDetail2 = id => {
  return request({
    url: `${preFixUrl}/outpatientClinicV2/getJyReportDetail/?sheetId=${id}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}


/**
 * 获取检查报告列表
 * @param {*} 
 * @returns
 */
export const getJcReportList2 = data => {
  return request({
    url: `${preFixUrl}/outpatientClinicV2/getJcReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 检查详情
 * @param {*} applicationNumber 申请单号
 * @param {*} sign md5签名
 * @returns
 */
export const getJcReportDetail2 = (applicationNumber,sign) => {
  return request({
    url: `${preFixUrl}/outpatientClinicV2/getJcReportDetail?applicationNumber=${applicationNumber}&sign=${sign}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

/**
 * 检查详情-新，门诊、住院
 * @param {*} applicationNumber 申请单号
 * @param {*} sign md5签名
 * @returns
 */
export const getJcReportDetail3 = (applicationNumber,sign) => {
  return request({
    url: `${preFixUrl}/outpatientClinicV2/getJcReportDetailHis?applicationNumber=${applicationNumber}&sign=${sign}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

/**
 * 体检报告
 * @param {*} data
 * @returns
 */
export const getPhysicalExam2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 体检报告详情
 * @param {*} idCardNo
 * @returns
 */
export const getPhysicalExamNo2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getReportDetailPost`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取用户体检数据对比分析-新版
 * @param {*} idCardNo
 * @returns
 */
export const getHealthDataListNew2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getHealthDataListNew`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取项目趋势
 * @param {*} idCardNo
 * @returns
 */
export const getItemTrend2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getItemTrend`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 *体检检查报告列表
 * @param {*} data
 * @returns
 */
export const getPJcReportList2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getJcReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 *体检检验报告列表
 * @param {*} data
 * @returns
 */
 export const getPJyReportList2 = data => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getJyReportList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}


/**
 * 体检检验报告详情
 * @param {*} idCardNo
 * @returns
 */
export const getPJyReportDetails2 = (data) => {
  return request({
    url: `${preFixUrl}/physicalExamV2/getJyReportDetails`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}